import { IconX } from '@tabler/icons-react';
import WrapperFormField from 'components/FormData/fields/WrapperFormField';
import { MultiSelect, Select } from 'crm-core';
import React, { useEffect } from 'react';
import { useTranslation } from '../../../../hooks/useTranslation';
import { DataTableColumn } from '../../utils/types';
declare var bootstrap: any;

interface OffcanvasFilterPanelProps {
  tableId: string;
  columns: DataTableColumn[];
  offcanvasFilters: { [key: string]: string };
  setOffcanvasFilters: React.Dispatch<
    React.SetStateAction<{ [key: string]: string }>
  >;
  onApplyFilter: (activeFilterKey: string, filterInputValue: string) => void;
}

// This component manages the offcanvas filter panel, allowing users to input filter values
function OffcanvasFilterPanel({
  tableId,
  columns,
  offcanvasFilters,
  setOffcanvasFilters,
  onApplyFilter,
}: OffcanvasFilterPanelProps) {
  const { t } = useTranslation();
  const [initOffcanvasFilters, setInitOffcanvasFilters] = React.useState<{
    [key: string]: string;
  }>({});
  React.useEffect(() => {
    setInitOffcanvasFilters(offcanvasFilters);
  }, [offcanvasFilters]);

  useEffect(() => {
    var popoverTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="popover"]'),
    );
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
      return new bootstrap.Popover(popoverTriggerEl);
    });
  }, []);

  // The offcanvas container that slides in from the right
  return (
    <div
      className="offcanvas offcanvas-end"
      tabIndex={-1}
      id={'offcanvasFilter-' + tableId}
      aria-labelledby={'offcanvasFilterLabel-' + tableId}
    >
      <div className="offcanvas-header">
        <h2 className="offcanvas-title" id={'offcanvasFilterLabel-' + tableId}>
          {t('FILTER')}
        </h2>
        <button
          type="button"
          className="btn-close text-reset"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        />
      </div>
      <div className="offcanvas-body">
        <div className="row">
          {/* Render a text input for each column to capture filter terms */}
          {columns
            .filter((col) => !col.filterHide)
            .map((col) => (
              <div key={col.key} className="col-12 mb-3">
                {col.key === 'createdAt' ? (
                  <div>
                    <div className="datagrid-title">
                      {col.filterLabel || col.label}
                    </div>
                    <div className="d-flex">
                      <input
                        type="date"
                        className="form-control me-2"
                        value={
                          offcanvasFilters[col.filterKey || col.key]?.split(
                            ',',
                          )[0] || ''
                        }
                        onChange={(e) => {
                          const toDate =
                            offcanvasFilters[col.filterKey || col.key]?.split(
                              ',',
                            )[1] || '';
                          setOffcanvasFilters((prev) => ({
                            ...prev,
                            [col.filterKey || col.key]:
                              `${e.target.value},${toDate}`,
                          }));
                        }}
                      />
                      <input
                        type="date"
                        className="form-control"
                        value={
                          offcanvasFilters[col.filterKey || col.key]?.split(
                            ',',
                          )[1] || ''
                        }
                        onChange={(e) => {
                          const fromDate =
                            offcanvasFilters[col.filterKey || col.key]?.split(
                              ',',
                            )[0] || '';
                          setOffcanvasFilters((prev) => ({
                            ...prev,
                            [col.filterKey || col.key]:
                              `${fromDate},${e.target.value}`,
                          }));
                        }}
                      />
                    </div>
                  </div>
                ) : col.filterOptions ? (
                  <div>
                    {col.filterMultiOptions ? (
                      <WrapperFormField
                        id={tableId + col.key}
                        label={col.filterLabel || col.label}
                      >
                        <MultiSelect
                          value={
                            offcanvasFilters[col.filterKey || col.key]?.split(
                              ',',
                            ) || []
                          }
                          options={col.filterOptions}
                          onChange={(val: any) => 
                            setOffcanvasFilters((prev) => ({
                              ...prev,
                              [col.filterKey || col.key]: val.map(String).join(','),
                            }))
                          }
                        />
                      </WrapperFormField>
                    ) : (
                      // <NAUMultiSelect
                      //   id={tableId + col.key}
                      //   label={col.filterLabel || col.label}
                      //   value={offcanvasFilters[col.filterKey || col.key]?.split(',') || []}
                      //   defaultValue={
                      //     offcanvasFilters[col.filterKey || col.key]?.split(',') || []
                      //   }
                      //   options={col.filterOptions}
                      //   onChange={(e) => {
                      //     const selectedRoles = Array.from(
                      //       e.target.selectedOptions,
                      //       (option) => option.value,
                      //     );

                      //     setOffcanvasFilters((prev) => ({
                      //       ...prev,
                      //       [col.filterKey || col.key]: selectedRoles.join(','),
                      //     }));
                      //   }}
                      // />
                      <WrapperFormField label={col.filterLabel || col.label}>
                        <Select
                          onChange={(val) => {
                            setOffcanvasFilters((prev) => ({
                              ...prev,
                              [col.filterKey || col.key]: val,
                            }));
                          }}
                          value={
                            offcanvasFilters[col.filterKey || col.key] || ''
                          }
                          options={col.filterOptions}
                          name={col.filterKey || col.key}
                        />
                      </WrapperFormField>
                      // <NAUSelect
                      //   label={col.filterLabel || col.label}
                      //   value={offcanvasFilters[col.filterKey || col.key] || ''}
                      //   defaultValue={offcanvasFilters[col.filterKey || col.key] || ''}
                      //   options={col.filterOptions}
                      //   onChange={(e) => {
                      //     setOffcanvasFilters((prev) => ({
                      //       ...prev,
                      //       [col.filterKey || col.key]: e.target.value,
                      //     }));
                      //   }}
                      // />
                    )}
                  </div>
                ) : (
                  <div>
                    <div className="datagrid-title">
                      {col.filterLabel || col.label}{' '}
                      {col.filterHint && (
                        <span
                          className="form-help"
                          data-bs-toggle="popover"
                          data-bs-trigger="hover"
                          data-bs-placement="top"
                          data-bs-html="true"
                          data-bs-content={`<p>${col.filterHint}</p>`}
                        >
                          ?
                        </span>
                      )}
                    </div>
                    <div className="position-relative">
                      <input
                        type="text"
                        className="form-control"
                        value={offcanvasFilters[col.filterKey || col.key] || ''}
                        onChange={(e) =>
                          setOffcanvasFilters((prev) => ({
                            ...prev,
                            [col.filterKey || col.key]: e.target.value,
                          }))
                        }
                      />
                      {offcanvasFilters[col.filterKey || col.key] && (
                        <IconX
                          size={16}
                          role="button"
                          className="position-absolute top-50 end-0 translate-middle-y me-2"
                          onClick={() =>
                            setOffcanvasFilters({
                              ...offcanvasFilters,
                              [col.filterKey || col.key]: '',
                            })
                          }
                        />
                      )}
                    </div>
                  </div>
                )}
              </div>
            ))}
        </div>
        <div className="mt-3">
          <button
            className="btn btn-primary"
            type="button"
            data-bs-dismiss="offcanvas"
            onClick={() => {
              Object.entries(offcanvasFilters)
                .filter(([_, val]) => val)
                .map(([key, value]) => {
                  onApplyFilter(key, value);
                });
            }}
          >
            {t('SAVE')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default OffcanvasFilterPanel;
